import React, { useEffect, useState } from "react";

import { v4 as uuidv4 } from "uuid";
// import LoadingButton from "components/LoadingButton";
// import MDButton from "components/MDButton";
// import { Card, Grid, TextField } from "@mui/material";
import MuiModal from "components/MuiModal";
import { reportIssue } from "services/common-service";
import useLoading from "hooks/use-loading";
import useAlert from "hooks/use-alert";

// react-router components
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";
// import WarningIcon from "@mui/icons-material/Warning";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
// import MDInput from "components/MDInput";
// Material Dashboard 2 React example components
import Breadcrumbs from "examples/Breadcrumbs";
import NotificationItem from "examples/Items/NotificationItem";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarIconButton,
  navbarMobileMenu,
  navbarRow,
} from "examples/Navbars/DashboardNavbar/styles";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
// Material Dashboard 2 PRO React context
import {
  setMiniSidenav,
  setOpenConfigurator,
  setTransparentNavbar,
  useMaterialUIController,
} from "context";
import { Alert } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "services/auth-service";
import { planLimitCheck } from "tutor/services/dashboard-service";
import { subTutorPlanLimitCheck } from "subtutor/services/dashboard-service";
import { studentPlanLimitCheck } from "student/services/dashboard-service";
import { checkPlanActions, checkPlanSelector } from "store/check-plan-slice";

import { loginActions, loginSelector, logoutHandler } from "store/login-slice";
import Badge from "@mui/material/Badge";
import ReportIssueForm from "./ReportIssueForm";
import { isFeePaid } from "../../../student/services/class-fees-services";
import fetchUnreadMessageCountForSubtutor from "../../../subtutor/services/notification-service";
import fetchUnreadMessageCount from "../../../tutor/services/notification-service";
import fetchUnreadMessageCountForStudent from "../../../student/services/notification-service";

function DashboardNavbar({ absolute, light, isMini, breadCrumbs, objectArray, title }) {
  const { createAlert } = useAlert();
  const { setShowLoader } = useLoading();
  const [reportIssueModalOpen, setReportIssueModalOpen] = useState(false);
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator, darkMode } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const location = useLocation();
  // const route = useLocation().pathname.split("/").slice(1);
  const navigate = useNavigate();

  const { token, userRole, notificationCount } = useSelector(loginSelector);
  // const reduxdata = useSelector((state) => state.login);
  // console.log(reduxdata, "reduxdata");
  //
  // const [notificationCount, setNotificationCount] = useState(0);

  const [alertList, setAlertList] = useState([]);

  const reduxDispatch = useDispatch();
  const { isExpireAlert, isSubcriptionActive, isPlanExpired, planExpireDate, triggerChange } =
    useSelector(checkPlanSelector);

  // const [isExpireAlert, setIsExpireAlert] = useState(0);
  // const [isSubcriptionActive, setIsSubcriptionActive] = useState(0);
  // const [isPlanExpired, setIsPlanExpired] = useState(0);
  // const [planExpireDate, setPlanExpireDate] = useState("");

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /**
     The event listener that's calling the handleTransparentNavbar function when
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);
  // const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);

  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem icon={<Icon>email</Icon>} title="Check new messages" />
      <NotificationItem icon={<Icon>podcasts</Icon>} title="Manage Podcast sessions" />
      <NotificationItem icon={<Icon>shopping_cart</Icon>} title="Payment successfully completed" />
    </Menu>
  );

  // Styles for the navbar icons
  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });

  const loginState = useSelector(loginSelector);

  const signOutHandler = async () => {
    try {
      await logout(loginState.token);
      // eslint-disable-next-line no-empty
    } catch (err) {}
    reduxDispatch(logoutHandler());
    navigate("/authentication/sign-in");
  };

  const formSubmitHandler = async (phone, subject, message, images) => {
    try {
      setShowLoader(true);
      const res = await reportIssue(phone, subject, message, images, token);
      if (res.status) {
        createAlert(res.message, "success");
      } else {
        createAlert(res.message, "error");
      }
    } catch (error) {
      // console.log(error);
      createAlert(error.message, "error");
    }
    setShowLoader(false);
    setReportIssueModalOpen(false);
  };

  useEffect(async () => {
    let cleanUp = false;

    // console.log({ path: location.pathname, userRole, triggerChange });

    const getPlanLimits = async () => {
      try {
        let res;
        if (userRole === "tutor") {
          res = await planLimitCheck(token);
          // console.log(res, "tutor limit check");
        } else if (userRole === "subtutor") {
          res = await subTutorPlanLimitCheck(token);
          // console.log(res, "SubTutor plan limit check");
        } else {
          res = await studentPlanLimitCheck(token);
        }
        // console.log(res, "plan limit check");
        if (!cleanUp) {
          if (res.status) {
            const { planDetails, StudentCount, subTutorCount, totalStorage, storageLimitEXceeded } =
              res.data;
            const {
              expireAlert,
              expireDate,
              isPlanExpired: isPlanExpiredRes,
              isSubcription,
              storage_limit: storageLimit,
              student_limit: studentLimit,
              subtutor_limit: subtutorLimit,
            } = planDetails;

            const studentLimitAlert = `Your student limit is exceeded ${StudentCount} / ${studentLimit}`;
            const subtutorLimitAlert = `Your subtutor limit is exceeded ${subTutorCount} / ${subtutorLimit}`;
            const storageLimitAlert = `Your storage limit is exceeded ${totalStorage} / ${storageLimit} GB`;

            const alertArr = [];

            let isStudentLimitExceeded = false;
            let isSubtutorLimitExceeded = false;
            const isStorageLimitExceeded = storageLimitEXceeded;
            if (userRole === "tutor") {
              if (StudentCount > studentLimit) {
                isStudentLimitExceeded = true;
                alertArr.push(studentLimitAlert);
              }
              if (subTutorCount > subtutorLimit) {
                isSubtutorLimitExceeded = true;
                alertArr.push(subtutorLimitAlert);
              }
            } else if (subTutorCount > subtutorLimit && userRole === "subtutor") {
              // reduxDispatch(checkPlanActions.updateIsSubTutorLimitExceeded(true));
              isSubtutorLimitExceeded = true;
            } else if (StudentCount > studentLimit && userRole === "student") {
              isStudentLimitExceeded = true;
              // reduxDispatch(checkPlanActions.updateIsStudentLimitExceeded(true));
            }

            if (isStorageLimitExceeded) {
              // remove _GB from totalStorage
              // const totalStorage2 = totalStorage.replace(" GB", "");
              // // convert totalStorage2 to number
              // const totalStorage3 = parseFloat(totalStorage2);
              // if (totalStorage3 > storageLimit) {
              //
              // }
              alertArr.push(storageLimitAlert);
            }

            reduxDispatch(
              checkPlanActions.updateCheckPlanState({
                isExpireAlert: expireAlert,
                isSubcriptionActive: isSubcription,
                isPlanExpired: isPlanExpiredRes === 1,
                planExpireDate: expireDate,
                isStudentLimitExceeded,
                isSubTutorLimitExceeded: isSubtutorLimitExceeded,
                isStorageLimitExceeded,
              })
            );

            setAlertList(alertArr);
            // reduxDispatch(checkPlanActions.updateIsPlanExpired(true));
            // reduxDispatch(loginActions.updateIsPlanExpired(true));

            // console.log(res.data);
          } else if (res.plan_expired && res.plan_expired === true && userRole === "tutor") {
            // console.log("plan expired");
            // reduxDispatch(logoutHandler());
            // reduxDispatch(checkPlanActions.updateIsPlanExpired(true));
            reduxDispatch(loginActions.updateIsPlanExpired("true"));
          }
        }
      } catch (error) {
        // console.log(error, "Plan Limits");
      }
    };

    if (location.pathname !== "/dashboard" && userRole === "tutor") {
      getPlanLimits();
    }
    // if (location.pathname !== "/dashboard" && (userRole === "subtutor" || userRole === "student")) {
    if (userRole === "subtutor") {
      getPlanLimits();
    }
    if (userRole === "student") {
      getPlanLimits();
      const result = await isFeePaid(token);
      if (result.status) {
        reduxDispatch(loginActions.setStudentPaidOrNot(String(result.data.isStudentPaid)));
      }
      // reduxDispatch(loginActions.setStudentPaidOrNot("false"));
    }
    return () => {
      // cancel the request here
      cleanUp = true;
    };
  }, [location.pathname, userRole, triggerChange]);

  useEffect(() => {
    async function getNotifications() {
      try {
        if (userRole === "tutor") {
          const notificationCounter = await fetchUnreadMessageCount(token);
          if (notificationCounter.status) {
            reduxDispatch(loginActions.setNotificationCount(notificationCounter.data));

            // setNotificationCount(0);
          }
        } else if (userRole === "subtutor") {
          const notificationCounter = await fetchUnreadMessageCountForSubtutor(token);
          if (notificationCounter.status) {
            reduxDispatch(loginActions.setNotificationCount(notificationCounter.data));
            // setNotificationCount(0);
          }
        } else if (userRole === "student") {
          const notificationCounter = await fetchUnreadMessageCountForStudent(token);
          if (notificationCounter.status) {
            reduxDispatch(loginActions.setNotificationCount(notificationCounter.data));
            // setNotificationCount(0);
          }
        } else {
          console.log("staff");
        }
      } catch (error) {
        console.log(error, "Notifications call error");
      }
    }
    getNotifications();
    const interval = setInterval(() => {
      getNotifications();
    }, 60000); // Run the API call every minute (60000 milliseconds)

    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }, [location.pathname, userRole, triggerChange]);

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light, darkMode })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
          <Breadcrumbs
            icon="home"
            title={title}
            route={breadCrumbs}
            objectArray={objectArray}
            light={light}
          />
        </MDBox>
        {isMini ? null : (
          <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
            <MuiModal
              open={reportIssueModalOpen}
              onClose={() => {
                setReportIssueModalOpen(false);
              }}
            >
              <ReportIssueForm onSubmitHandler={formSubmitHandler} />
            </MuiModal>
            {/* <MDBox pr={1}>
              <MDInput label="Search here" />
            </MDBox> */}
            <MDBox color={light ? "white" : "inherit"}>
              <Button
                size="small"
                color="warning"
                style={{
                  marginBottom: "-5px",
                }}
                sx={navbarIconButton}
                onClick={() => {
                  setReportIssueModalOpen(true);
                }}
              >
                Report Issue
              </Button>
              <Link to="/profile">
                <IconButton sx={navbarIconButton} size="small" disableRipple>
                  <Icon sx={iconsStyle}>account_circle</Icon>
                </IconButton>
              </Link>
              {/* <IconButton sx={navbarIconButton} style={{ color: "red" }} size="small" disableRipple> */}
              {/*  <NotificationsActiveIcon /> */}

              {/* </IconButton> */}
              {userRole !== "staff" && (
                <Link to="/notifications">
                  <Badge badgeContent={notificationCount} color="primary">
                    <NotificationsActiveIcon />
                  </Badge>
                </Link>
              )}

              <IconButton
                size="small"
                color="inherit"
                sx={navbarMobileMenu}
                onClick={handleMiniSidenav}
              >
                <Icon sx={iconsStyle} fontSize="medium">
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon>
              </IconButton>
              <IconButton
                size="small"
                color="inherit"
                sx={navbarIconButton}
                onClick={handleConfiguratorOpen}
              >
                <Icon sx={iconsStyle}>settings</Icon>
              </IconButton>
              {/* <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
                onClick={handleOpenMenu}
              >
                <Icon sx={iconsStyle}>notifications</Icon>
              </IconButton> */}
              <IconButton
                size="small"
                color="error"
                sx={navbarIconButton}
                variant="contained"
                onClick={signOutHandler}
              >
                <LogoutIcon sx={iconsStyle} />
              </IconButton>
              {renderMenu()}
            </MDBox>
          </MDBox>
        )}
      </Toolbar>
      {location.pathname !== "/dashboard" &&
        location.pathname !== "/currentplan-upgradeplan" &&
        location.pathname !== "/currentplan-upgradeplan/checkout" && (
          <>
            {alertList.length > 0 && (
              <>
                {alertList.map((alert) => (
                  <Alert key={uuidv4()} severity="error">
                    {alert}
                  </Alert>
                ))}
                {userRole === "tutor" && (
                  <Alert severity="error">
                    Please Upgrade Your Plan{" "}
                    <NavLink to="/currentplan-upgradeplan" style={{ fontSize: "17px" }}>
                      Click here to buy new plan
                    </NavLink>
                  </Alert>
                )}
              </>
            )}
            {userRole === "tutor" && isExpireAlert === 1 && isSubcriptionActive === 0 && (
              <>
                {isPlanExpired === 1 && (
                  <Alert severity="error">
                    Your plan is expired{" "}
                    <NavLink to="/currentplan-upgradeplan" style={{ fontSize: "17px" }}>
                      Click here to buy new plan
                    </NavLink>
                  </Alert>
                )}
                {isPlanExpired === 0 && (
                  <Alert severity="warning">
                    Your plan will be expire on {planExpireDate}{" "}
                    <NavLink to="/currentplan-upgradeplan" style={{ fontSize: "17px" }}>
                      Click here to buy new plan
                    </NavLink>
                  </Alert>
                )}
              </>
            )}
          </>
        )}
      {/* {location.pathname !== "/dashboard" &&
        location.pathname !== "/currentplan-upgradeplan" &&
        location.pathname !== "/currentplan-upgradeplan/checkout" &&
        } */}
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
  objectArray: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
  breadCrumbs: PropTypes.arrayOf(PropTypes.any).isRequired,
  objectArray: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

export default React.memo(DashboardNavbar);
